/**
 * List Type Constants
 * Enumeration of available list types in the system.
 */
export const ListType = {
  MAIN: 'main',
  USER_LIST: 'user_list',
  TOMORROW: 'tomorrow',
  DAILY_HABITS: 'dailyhabits'
};

/**
 * Check if a list type is a special list (not user-created)
 * @param {string} listType - The list type to check
 * @returns {boolean} True if the list type is special
 */
export const isSpecialList = (listType) => {
  return listType !== ListType.USER_LIST;
};

/**
 * Check if a list type is the main list
 * @param {string} listType - The list type to check
 * @returns {boolean} True if the list type is main
 */
export const isMainList = (listType) => {
  return listType === ListType.MAIN;
};

/**
 * Check if a list type is the tomorrow list
 * @param {string} listType - The list type to check
 * @returns {boolean} True if the list type is tomorrow
 */
export const isTomorrowList = (listType) => {
  return listType === ListType.TOMORROW;
};

/**
 * Check if a list type is the daily habits list
 * @param {string} listType - The list type to check
 * @returns {boolean} True if the list type is dailyhabits
 */
export const isDailyHabitsList = (listType) => {
  return listType === ListType.DAILY_HABITS;
};

